export const LANG_EXPERIMENT_INTERNAL_ID = 'header_lang_picker';
export const HIDE_REGION_INTERNAL_ID = 'hide_region';
export const HIDE_SUBSCRIBE_INTERNAL_ID = 'hide_subscribe';
export const HIDE_B2B_INTERNAL_ID = 'hide_b2b';
export const HIDE_PROJECTS_INTERNAL_ID = 'hide_projects';
export const HIDE_MOBILE_APP_INTERNAL_ID = 'hide_mobile_app';
export const HIDE_PRO_INTERNAL_ID = 'hide_pro';
